import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import { Text } from "@cinch-labs/design-system";
import { currencyValueFormatter, getMake, getModel, LinkToProductDetail, useViewport } from "@cinch-labs/shared-util";
import Image from "../image/image";
import styles from "./vehicle-information.module.css";
import { useAdobeTarget } from "@cinch-labs/adobe";
export function VehicleInformation(param) {
    var vehicle = param.vehicle, sendDigitalDataEvent = param.sendDigitalDataEvent, adminFeeFlag = param.adminFeeFlag, adminFeeValueInPence = param.adminFeeValueInPence;
    var imageUrl = vehicle.imageUrl, make = vehicle.make, model = vehicle.model, derivative = vehicle.derivative, priceInPence = vehicle.priceInPence, registrationDate = vehicle.registrationDate, id = vehicle.id;
    var regYear = new Date(registrationDate).getFullYear();
    var vehicleName = "".concat(regYear, " ").concat(getMake(make), " ").concat(getModel(make, model));
    var dontWantCarExperiment = useAdobeTarget("I_DONT_WANT_THIS_CAR");
    var basicVehicleInfo = {
        make: make,
        model: model,
        id: id
    };
    var vw = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    }).vw;
    var isMobile = vw < 768;
    return isMobile ? /*#__PURE__*/ _jsxs("div", {
        className: cx(styles["basketBannerVehicleInfoContainer"], _define_property({}, styles["basketBannerVehicleInfoContainerWithAdminFee"], adminFeeFlag)),
        children: [
            dontWantCarExperiment && /*#__PURE__*/ _jsx(LinkToProductDetail, {
                basicVehicleInfo: basicVehicleInfo,
                children: /*#__PURE__*/ _jsx(Image, {
                    sendDigitalDataEvent: sendDigitalDataEvent,
                    src: imageUrl,
                    alt: vehicleName,
                    className: styles["vehicleImageMobile"],
                    lazy: true,
                    clickable: true
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cx(styles["priceRow"], _define_property({}, styles["priceRowWithAdminFee"], adminFeeFlag)),
                children: [
                    /*#__PURE__*/ _jsx(LinkToProductDetail, {
                        basicVehicleInfo: basicVehicleInfo,
                        className: styles["underlineText"],
                        children: /*#__PURE__*/ _jsx(Text, {
                            id: "description-of-active-order-vehicle",
                            className: styles["vehicleInfo"],
                            fontSizeFixed: adminFeeFlag ? "s" : "m",
                            children: "".concat(vehicleName, " ").concat(derivative)
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles["price"],
                        fontSizeFixed: adminFeeFlag ? "s" : "m",
                        children: currencyValueFormatter(priceInPence, true)
                    })
                ]
            }),
            adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ _jsxs("div", {
                className: cx(styles["priceRow"]),
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        id: "description-of-active-order-vehicle",
                        className: styles["vehicleInfo"],
                        fontSizeFixed: "s",
                        children: "Admin fee"
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles["price"],
                        fontSizeFixed: "s",
                        children: currencyValueFormatter(adminFeeValueInPence, true)
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LinkToProductDetail, {
                basicVehicleInfo: basicVehicleInfo,
                className: styles["vehicleImageLink"],
                children: /*#__PURE__*/ _jsx(Image, {
                    sendDigitalDataEvent: sendDigitalDataEvent,
                    src: imageUrl,
                    alt: vehicleName,
                    className: cx(styles["vehicleImage"], _define_property({}, styles["vehicleImageWithAdminFee"], adminFeeFlag)),
                    lazy: true,
                    clickable: true
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cx(styles["basketBannerVehicleInfoContainer"], _define_property({}, styles["basketBannerVehicleInfoContainerWithAdminFee"], adminFeeFlag)),
                children: [
                    adminFeeFlag ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                id: "active-order-banner",
                                className: styles["bannerHeading"],
                                children: "Your order"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: cx(styles["priceRow"]),
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles["basketBannerVehicleInfo"],
                                        children: /*#__PURE__*/ _jsxs(LinkToProductDetail, {
                                            basicVehicleInfo: basicVehicleInfo,
                                            className: styles["underlineText"],
                                            children: [
                                                /*#__PURE__*/ _jsx(Text, {
                                                    id: "description-of-active-order-vehicle",
                                                    fontSizeFixed: "m",
                                                    children: vehicleName
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    fontSizeFixed: "s",
                                                    children: "".concat(derivative)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        className: styles["price"],
                                        fontSizeFixed: "m",
                                        children: currencyValueFormatter(priceInPence, true)
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles["basketBannerVehicleInfo"],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        id: "active-order-banner",
                                        className: styles["bannerHeading"],
                                        children: "Your order"
                                    }),
                                    /*#__PURE__*/ _jsxs(LinkToProductDetail, {
                                        basicVehicleInfo: basicVehicleInfo,
                                        className: styles["underlineText"],
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                id: "description-of-active-order-vehicle",
                                                fontSizeFixed: "l",
                                                children: vehicleName
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                fontSizeFixed: "m",
                                                children: "".concat(derivative)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                className: styles["price"],
                                fontSizeFixed: "l",
                                children: currencyValueFormatter(priceInPence, true)
                            })
                        ]
                    }),
                    adminFeeFlag && adminFeeValueInPence && /*#__PURE__*/ _jsxs("div", {
                        className: cx(styles["priceRow"], styles["priceRowWithAdminFee"]),
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                fontSizeFixed: "s",
                                children: "Admin fee"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSizeFixed: "s",
                                children: currencyValueFormatter(adminFeeValueInPence, true)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default VehicleInformation;
